<template>
	<div class="industrialpark" >
		<leftnav class="fl" itemcode="B-DDTP"></leftnav> 
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage" v-if="userdata.groupType != 2">
				 
				<div class="heightVh95 whitebox container-flex-center">
								<freeUserTips :type="4" :bgtype="0" isShowPageTitle="当地图谱"></freeUserTips>
							</div> 
					</div>
				 
			</div>
		</div>
	</template>
	
	<script>
		import { mapState, mapMutations, mapGetters } from "vuex";
	
		export default {
			name: 'chainEnterprise',
			computed: {
			...mapState({
			isCollapse: (state) => state.isCollapse,
			}),
			...mapGetters(['isCollapse'])
			},
			data() {
				return { 
				areatype:"province",
				isShowProvince:false,
				hiddenCity:true,
				title: "当地产业图谱", 
				calCuData:{id:11,name:'北京',type:'city'},  
				marketStr:false,
				calcuAreaId:"",//计算的城市
				userdata:{currentCity:{isZhixia:false}},
				curWebsite:this.$api.getWebsiteType(), 
				newnotionlist:[],
				tiptext:"",  
				totalPage:1,
				resdata:{},
				chainListCityName:"",
				chainListCityId:0,
				notionlist:[],
				notionlist1:[],
				notionlist2:[],
				notionlist3:[],
				notionlist4:[],
				notionlist5:[],
				notionlist6:[], 
				notioncodeA:'A',
				notioncodeB:'A01',
				notionCode:'A0101',
				namelist:"",
				codelist:"",
				getnotionlist:[],
				notiontext: '',chooseNotionlist:['A','A01','A0101',0,0],
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 20, //每一页显示的数据条数
				total: 0, //记录总数 
				maxPage:10,  //最大页数  
				} 
			},  
			beforeCreate() {
				
			},
			created() { 
			  
				},
				 
				mounted(){
					document.getElementById('app').style.background = "#f0f3f5";    
				 
				},
			methods: {  
				//计算到底是本省还是本市
				// calcuCityType(areaid){
				// 	var areatype={type:"",id:areaid};
				// 	if(areaid.length<2){
				// 		areatype.type == 'province';
				// 	}else{
				// 		areatype.type == 'city';
				// 	}
				// },
				calcuCityType(type){
					//如果研究招商投资 本市本省都展示，默认为本省；
					//如果是信贷园区治理 则只展示本市 默认为本市2024.429改为显示本省产业链
					this.bus.$emit('loading', true);   
					this.isShowProvince=this.curWebsite.type == 1 || this.curWebsite.type == 4 || this.curWebsite.type == 5 || this.curWebsite.type == 7 || this.curWebsite.type == 6 || this.curWebsite.type == 8;
					var text1=this.isShowProvince?'province':'city';
					this.areatype = this.$route.query.type ? this.$route.query.type : text1;  
					this.hiddenCity= !this.userdata.currentCity.noZhixia && this.isShowProvince; //当前版本为招商研究投资且为直辖市时不展示本市产业链
					// this.isShowProvince=  this.curWebsite.type == 1 || this.curWebsite.type == 5 || this.curWebsite.type == 7 || this.curWebsite.type == 6; 
					// this.areatype= this.isShowProvince ? 'province' : 'city'; 
					if(this.areatype == 'city'){
						this.calCuData={id:this.userdata.currentCity.id,text:this.userdata.currentCity.text,type:this.userdata.currentCity.type,itemcode:'B-DDTP'};
					}else{
							this.calCuData={id:this.userdata.province,text:this.userdata.provinceText,type:'province',itemcode:'B-DDTP'};
							if(this.curWebsite.type == 6){
								this.calCuData.itemcode='B-BSTP';
							}
					}
					this.getlocalchainlist();
					this.getuserSetNotion();
				},
				//获取用户设置的概念
				getuserSetNotion(){
					var _this=this;
					this.$axios.get(this.$api.cyl.localchain.get()+'?areaId='+this.calCuData.id,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						console.log('用户设置的概念数据',res.data.data)
						if(res.data.success){    
							 _this.namelist=res.data.data.notionText; 
								_this.codelist=res.data.data.notion;
								if(	_this.codelist!=''){ 
									// _this.getdefaultlist(res.data.data.notionText,res.data.data.notion);   
									_this.getnotionnumNew(res.data.data.areaId,res.data.data.notionText,res.data.data.notion); 
								}else{
									_this.tiptext='暂无产业关注概念，请前往设置';
									_this.$message({type:'warning',message:_this.tiptext});
									_this.bus.$emit('loading', false);  
								}
						}else{ 
							
						} 
					});
				},
				//暂用的一级产业到产业链的转换 
				atTimeSelect(data,step){
					if(step == 1){
						this.notionlist1=data.childrenList; this.notioncodeA = data.value;
				 
						this.notionlist2=this.notionlist1[0].newChildrenList; 
						this.notioncodeB = this.notionlist1[0].value;
						this.notionCode=this.notionlist2[0].notionCode;
					}else if(step == 2){
						this.notionlist2=data.newChildrenList;
						this.notioncodeB = data.value;
						this.notionCode=this.notionlist2[0].notionCode;
					}else{ 
							this.notionCode=data.notionCode;
					} 
					this.getlist();
				},
				getNotionTreeList(bigdata,smdata){ 
					var  scData=[];//将二级全部提出
					for(var d=0;d<bigdata.length;d++){
						scData=scData.concat(bigdata[d].children) 	
					}
					//提前在二级里放个新的空数组
					for(var d=0;d<scData.length;d++){
						scData[d].newChildrenList=[];
					}
					//将二级数据code和用户选择的三级数据code相匹配插值
					for(var d=0;d<scData.length;d++){ 
						let scCode=scData[d].value.substr(0,1),matchCode="";
						if(scCode == 'A' || scCode == "C"){
							matchCode=scData[d].value.substr(0,3);
						}else if(scCode == 'B'){
							matchCode=scCode;
						}else{
							matchCode=scData[d].value.substr(0,2); 
						}
						for(var e=0;e<smdata.length;e++){
							let smCode=smdata[e].notionCode.substr(0,1),matchCode1="";
							if(smCode == 'A' || smCode == "C"){
								matchCode1=smdata[e].notionCode.substr(0,3);
							}else if(smCode == 'B'){
								matchCode1=smCode;
							}else{
								matchCode1=smdata[e].notionCode.substr(0,2); 
							}
							if(matchCode == matchCode1){
								// console.log(scData[d].value,smdata[e].notionCode)
								scData[d].newChildrenList.push(smdata[e]);  
							}  
						}
					};
					//移除没有被匹配到的二级数据
					scData=scData.filter(list=>{
						return list.newChildrenList.length>0
					}) 
					//将已经匹配好筛选过的二级数据与一级数据相匹配插值
					for(var d=0;d<bigdata.length;d++){
						bigdata[d].childrenList=[];
					for(var i=0;i<scData.length;i++ ){  
							if(scData[i].value.indexOf(bigdata[d].value) == 0){
									bigdata[d].childrenList.push(scData[i]);
							}
							if(bigdata[d].value == 'E' && scData[i].value.indexOf('B') == 0){
								bigdata[d].childrenList.push(scData[i]);
							} 
						}  
					} 
					//移除没有被匹配到的一级数据
					bigdata=bigdata.filter(list=>{
						return list.childrenList.length>0
					})
					// console.log('获取一级概念数据列',bigdata);
					this.newnotionlist=bigdata;//存值
					this.atTimeSelect(bigdata[0],1); //执行
				},
				getdefaultlist(data){  
					var ajaxurl=this.$api.tag.notion.list() + '?level=3';
					var _this=this;
					this.getAxiosData(ajaxurl,this.userdata.token,function(res){ 
						 
					_this.getNotionTreeList(res.list,data); 
					})  
				},
				//获取用户设置的概念下数量
				getnotionnumNew(areaid,namelist,codelist){   
					var dttd='&notion='+codelist; 
					var _this=this;   
					// var  areaja='&'+this.calCuData.type+'='+this.calCuData.id; 
					var  areaja='&'+this.calCuData.type+'='+this.calCuData.id; 
					let ajaxurld=this.$api.cyl.enterprise.list()+'?page=1&type=0&search=0&calNotion=1&calCNC=1'+dttd+areaja;  
					console.log(ajaxurld);
					this.$axios.get(ajaxurld,{headers:{AuthToken:this.userdata.token}}).then(function(res){    
						var resnumdata=res.data.extend.cityNotionList;
						//console.log('resnumdata',resnumdata)
						_this.getdefaultlist(resnumdata);   
						_this.bus.$emit('loading', false);   
					}).catch(function (error) {
						 //console.log(error);
					});	
				},
				//获取当地图谱列表内容
				getlocalchainlist(pages){
					var _this=this;
					this.$axios.get(this.$api.cyl.localchain.list()+'?areaId='+this.calCuData.id,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						if(res.data.success){   
							_this.resdata=res.data.list;    
						}else{ 
								
						} 
					}).catch(function (error) {}); 
				},
				//产业链公司分布（最底下)
				getlist(pages){
						var _this=this;
						var ajpage=1; 
						if(pages){
							ajpage=pages;
						} 
						this.page=ajpage;
						var notionja =this.splicing('notion',this.notionCode);
						// var ajaxurl = this.$api.cyl.notion.chainenterprise()+'?notion='+this.notionCode+'&cityid='+this.userdata.city;\
						 
						var ajaxurl = this.$api.cyl.notion.chainenterprise()+'?notionCode='+this.notionCode+'&areaId='+this.calCuData.id; 
						console.log(ajaxurl,'a')
						// this.bus.$emit('loading', true);  
						this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
							_this.bus.$emit('loading', false);   
				   console.log(ajaxurl,res.data);
				   //console.log(res.data);
							_this.notionlist3=res.data.list;
							
						}).catch(function (error) {
							// 请求失败处理 //console.log(error);
						});   
				}, 
			}
		}
	</script>
	
	<style> 
	</style>
	